<a
  [routerLink]="routerLink"
  class="tw-flex tw-items-center tw-gap-3 tw-rounded-xl tw-border tw-border-solid tw-border-slate-200 tw-bg-white tw-p-4 tw-no-underline tw-transition-colors hover:tw-bg-slate-50">
  <div class="tw-flex tw-size-11 tw-shrink-0 tw-items-center tw-justify-center tw-rounded-lg tw-bg-slate-100">
    <ate-icon name="document-text" class="tw-size-5 tw-text-slate-500"></ate-icon>
  </div>
  <div class="tw-flex tw-min-w-0 tw-flex-grow tw-flex-col tw-justify-between tw-gap-3 md:tw-flex-row md:tw-gap-0">
    <div class="tw-flex tw-min-w-0 tw-flex-col">
      <p class="tw-m-0 tw-truncate tw-font-bold tw-text-slate-800">{{ title }}</p>
      <!-- Wraps rather than overflowing: in a narrow tile the status phrase drops to its own lines instead of running
         under the total (MP-11474). The separator sits inside the lead so it never wraps onto a line by itself. -->
      <div class="md:gap-3 tw-flex tw-min-w-0 tw-flex-wrap tw-items-center tw-gap-x-1 tw-text-sm tw-text-slate-500">
        @if (metaLead) {
          <span class="tw-truncate">{{ metaLead }} ·</span>
        }
        <span>{{ statusPhrase }}</span>
      </div>
    </div>

    <div class="tw-flex tw-shrink-0 tw-flex-row tw-flex-wrap tw-items-end tw-gap-1 md:tw-flex-col">
      <span class="tw-inline-flex tw-items-center tw-gap-1.5 tw-rounded-full tw-px-2.5 tw-py-0.5 tw-text-xs tw-font-semibold" [ngClass]="pillClass">
        <span class="tw-size-1.5 tw-rounded-full tw-bg-current"></span>
        {{ status }}
      </span>
      <span class="tw-font-bold tw-text-slate-800">{{ amount | currency: 'GBP' : 'symbol' : '1.2-2' }}</span>
    </div>
  </div>

  <ate-icon name="chevron-right-v2" class="tw-size-4 tw-shrink-0 tw-text-slate-400"></ate-icon>
</a>
